import { HashLoader } from 'react-spinners';
import styles from './MainLoader.module.scss';

interface IProps {
  show: boolean;
  borderRadius?: number;
  minHeight?: number;
}

const MainLoader = (props: IProps) => {
  const { borderRadius = 30, minHeight = 96 } = props;
  return (
    <>
      {props.show && (
        <>
          <div
            className={styles.mainLoader}
            style={{
              borderRadius: borderRadius + 'px',
              minHeight: minHeight + '%',
            }}
          >
            <HashLoader size={30} color={'#0056A3'} loading={true} />
          </div>
        </>
      )}
    </>
  );
};

export default MainLoader;
